import React from 'react';
import { View } from 'react-native';
import LogoBankAccount from 'design-system/LogoBankAccount';
import RadioButton from 'design-system/RadioButton';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import { rem } from 'design-system/values';
import createStyleSheets from 'utils/createStyleSheets';
const RowAchAccount = ({ account, selected, style }) => {
    const styles = useStyles(styleSet);
    return (<View style={[styles.row, style]}>
      {selected !== undefined && (<>
          <RadioButton isChecked={selected} type="single"/>
          <Spacer.W16 />
        </>)}
      <LogoBankAccount size="R44" data={{ iconUrl: account.iconUrl ?? undefined }}/>
      <View style={styles.info}>
        <Text Text-16 numberOfLines={1} ellipsizeMode="tail" OffBlack>
          {account.name}
        </Text>
        <Text TextThin-14 numberOfLines={1} ellipsizeMode="tail" Gray>
          {`•••••• ${account.mask}`}
        </Text>
      </View>
    </View>);
};
const styleSet = createStyleSheets(() => ({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: rem(16),
    },
    info: {
        flex: 1,
        paddingHorizontal: rem(16),
    },
}));
export default RowAchAccount;
